export const buildTableHeader = (t) => [
  {
    id: 'name',
    type: 'text',
    value: t('mapping:dataTypes.table.name'),
  },
  {
    id: 'description',
    type: 'text',
    value: t('mapping:dataTypes.table.description'),
  },
  {
    id: 'action',
    type: 'actions',
    value: '',
  },
]
